import {Record, Map} from 'immutable';
import type {RecordOf} from 'immutable';

// TODO: ValidationsType should be redefined as a Record and used instead of
// the `validations: Map<ValidationsKey, any>` key used in FieldProps below
// type ValidationsType = {
//   format: ?string,
//   precision: ?number,
//   collectionId: ?string,
// };
export type ValidationsKey =
  | 'messages'
  | 'singleLine'
  | 'options'
  | 'pattern'
  | 'format'
  | 'precision'
  | 'collectionId'
  | 'minLength'
  | 'maxLength'
  | 'allowZero'
  | 'allowNegative'
  | 'notInRanges'
  | 'minValue'
  | 'maxValue'
  | 'unique'
  | 'beforeDate'
  | 'afterDate'
  | 'notEmpty'
  | 'acceptedExtensions'
  | 'minImageSize'
  | 'maxImageSize'
  | 'minImageWidth'
  | 'maxImageWidth'
  | 'minImageHeight'
  | 'maxImageHeight'
  | 'enumName'
  | 'prohibitedExtensions';

export type FieldProps = {
  id: string;
  editable: boolean;
  name: string;
  required: boolean;
  slug: string;
  type: string;
  helpText: string;
  validations: Map<ValidationsKey, any>;
  innerType?: string;
  toJS: any;
};

// Represents a Dynamo Collection Field
const Field: Record.Factory<FieldProps> = Record(
  {
    id: '', // ID
    editable: false, // Boolean
    name: '', // String
    required: false, // Boolean
    slug: '', // String
    type: '', // String
    innerType: '', // String
    helpText: '', // String
    validations: Map() as Map<ValidationsKey, any>, // Map * *
  } as FieldProps,
  'Field'
);

export default Field;

export type FieldType = RecordOf<FieldProps>;
